import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import LoginPage from "../features/auth/pages/LoginPage";
import NewPasswordPage from "../features/auth/pages/NewPasswordPage";
import DashboardPage from "../features/dashboard/pages/DashboardPage";
import TechnicianDashboard from '../features/dashboard/pages/Technician_Dashboard';
import SupervisorDashboardPage from "../features/dashboard/pages/SupervisorDashboardPage";
import WorkOrdersPage from "../features/dashboard/pages/WorkOrders";
import AssetsPage from "../features/assets/pages/AssetsPage";
import AssetDetailPage from "../features/assets/pages/AssetDetailPage";
import ProtectedRoute from "../shared/components/ProtectedRoute";
import Layout from "../shared/components/Layout";
import RequestsPage from "../features/dashboard/pages/RequestsPage";
import RequestDetailPage from "../features/dashboard/pages/RequestDetailPage";
import { useAuth } from "../shared/context/AuthContext";
import { ROLES } from "../shared/config/roleConfig";

// Scrolls to top on every route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Renders the correct dashboard based on user role
const RoleDashboard = () => {
  const { user } = useAuth();
  if (user?.role === ROLES.SUPERVISOR) {
    return <SupervisorDashboardPage />;
  }
  if (user?.role === ROLES.TECHNICIAN) {
    return <TechnicianDashboard />;
  }
  return <DashboardPage />;
};

// Redirects to the user's role-based default dashboard
const RoleBasedRedirect = () => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return null;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <Navigate to="/dashboard" replace />;
};

const AppRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/new-password" element={<NewPasswordPage />} />

      {/* PlantDirector routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Layout>
              <RoleDashboard />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/work-orders"
        element={
          <ProtectedRoute>
            <Layout>
              <WorkOrdersPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/requests"
        element={
          <ProtectedRoute>
            <Layout>
              <RequestsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/requests/:requestId"
        element={
          <ProtectedRoute>
            <Layout>
              <RequestDetailPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/assets"
        element={
          <ProtectedRoute>
            <Layout>
              <AssetsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/asset/:assetId"
        element={
          <ProtectedRoute>
            <Layout>
              <AssetDetailPage />
            </Layout>
          </ProtectedRoute>
        }
      />


    

      {/* Default redirect - role-aware */}
      <Route path="/" element={<RoleBasedRedirect />} />
      <Route path="*" element={<RoleBasedRedirect />} />
    </Routes>
    </>
  );
};

export default AppRoutes;